<template>
  <div>
    <p>Application no: <strong>{{applicantData ? applicantData.application_no : '--'}}</strong></p>
    <hr>
    <a-steps :current="step - 1">
      <a-step title="Register" />
      <a-step title="Personal Info" />
      <a-step title="Academic Info" />
      <a-step title="Uploads" />
      <a-step title="Submit" />
    </a-steps>

    <div class="p-2 border rounded mt-4">
      <div class="text-center mt-1">
        <strong class="font-italic text-primary mb-0">All the information are mandatory and should be same as that of matriculation records</strong>
      </div>
      <hr>
      <a-spin :spinning="loading">
        <div v-if="step === 2">
          <FormStepTwo :applicantData="applicantData" :applicationFormData="data" @saved="handleSaved"/>
        </div>
        <div v-else-if="step === 3">
          <FormStepThree :applicantData="applicantData" :applicationFormData="data" @saved="handleSaved" @previous="handlePrevious"/>
        </div>
        <div v-else-if="step === 4">
          <FormStepFour :applicantData="applicantData" :applicationFormData="data" @saved="handleSaved" @previous="handlePrevious"/>
        </div>
        <div v-else-if="step === 5">
          <FormStepFive :applicantData="applicantData" :applicationFormData="data" @saved="handleSaved" @previous="handlePrevious"/>
        </div>
        <div v-else>
          Default
        </div>
      </a-spin>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import FormStepTwo from '@/components/public/ApplicationForm/StepTwo/index'
import FormStepThree from '@/components/public/ApplicationForm/StepThree/index'
import FormStepFour from '@/components/public/ApplicationForm/StepFour/index'
import FormStepFive from '@/components/public/ApplicationForm/StepFive/index'

export default {
  name: 'ApplicationForm',
  props: ['data'],
  components: {
    FormStepTwo,
    FormStepThree,
    FormStepFour,
    FormStepFive,
  },
  mounted: function() {
    this.getApplicant()
  },
  computed: {
    ...mapState(['applicant']),
  },
  watch: {
    applicantData: function(val) {
      if (val) {
        this.step = val.step
      }
    },
  },
  data: function() {
    return {
      loading: false,
      step: 1,
      applicantData: null,
    }
  },
  methods: {
    getApplicant() {
      this.loading = true
      this.$http.get(`/api/application-form/show/${this.applicant.applicant_id}`, {
        params: {
          token: this.applicant.app_form_token,
        },
      }).then(({ data }) => {
        if (data.type === 'error') {
          this.$applicantAuth.logout()
        } else {
          this.loading = false
          this.applicantData = data.data
        }
      }).catch((error) => {
        console.log(error)
      })
    },
    handleSaved() {
      this.getApplicant()
    },
    handlePrevious(step) {
      this.step = step
    },
  },
}
</script>
